import React, { useState } from 'react';
import PrintInvoiceModal from './PrintInvoiceModal';
import { useSelector, useDispatch } from 'react-redux';
import { getFileUrl } from '@/services/CommonService';
import CurrencyCodeAdd from '@/components/common/CurrencyCodeAdd';

const CartProductListSidebar = ({ title, orderData }) => {
    const [printInvoiceModal, setPrintInvoiceModal] = useState(false);
    const [printKitchenModal, setPrintKitchenModal] = useState(false);

    return (
        <>
            <div className="rounded-2xl shadow-xs bg-white">
                <div className="p-4 border-b">
                    <h3 className="capitalize font-medium mb-3">{title && title}</h3>
                    <div className="pl-3">
                        {orderData?.order_items &&
                            orderData?.order_items.length > 0 &&
                            orderData?.order_items.map((cart, index) => (
                                <div key={index} className="mb-3 pb-3 border-b last:mb-0 last:pb-0 last:border-b-0 border-gray-2">
                                    <div className="flex items-center gap-3 relative">
                                        <h3 className="absolute top-5 ltr:-left-3 rtl:-right-3 text-sm w-[26px] h-[26px] leading-[26px] text-center rounded-full text-white bg-heading">
                                            {cart.quantity}
                                        </h3>
                                        <img src={getFileUrl(orderData?.items[index].file_name, 'product')} alt="thumbnail" className="w-16 h-16 rounded-lg flex-shrink-0" />
                                        <div className="w-full">
                                            <span className="text-sm font-medium capitalize transition text-heading">{cart.name}</span>
                                            <p className="capitalize text-xs mb-1.5">
                                                {cart?.item_variations?._ids &&
                                                    cart?.item_variations?._ids.length > 0 &&
                                                    cart?.item_variations?._ids.map((item_variation, ind) => (
                                                        <span key={ind}>
                                                            <span className="">{cart?.item_variations?.attribute_name[ind]}: </span>
                                                            <span className="">{cart?.item_variations?.name[ind]}</span>
                                                        </span>
                                                    ))}
                                            </p>
                                            <h4 className="text-xs font-semibold">
                                                <CurrencyCodeAdd price={cart.total_price} />
                                            </h4>
                                        </div>
                                    </div>
                                    <ul className="flex flex-col gap-1.5 mt-2">
                                        <li className="flex gap-1">
                                            <h3 className="capitalize text-xs w-fit whitespace-nowrap">Extras:</h3>
                                            <p className="text-xs">
                                                {cart?.item_extras?._ids &&
                                                    cart?.item_extras?._ids.length > 0 &&
                                                    cart?.item_extras?._ids.map((item_extra, ind1) => (
                                                        <span key={ind1}>
                                                            {cart?.item_extras?.name[ind1]}
                                                            {ind1 < cart?.item_extras?._ids.length - 1 && ','}
                                                        </span>
                                                    ))}
                                            </p>
                                        </li>
                                        {cart.instruction && cart.instruction !== '' && (
                                            <li className="flex gap-1">
                                                <h3 className="capitalize text-xs w-fit whitespace-nowrap">Instruction:</h3>
                                                <p className="text-xs">{cart.instruction}</p>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            ))}
                    </div>
                </div>
                <div className="p-4">
                    <div className="rounded-xl mb-6 border border-[#EFF0F6]">
                        <ul className="flex flex-col gap-2 p-3 border-b border-dashed border-[#EFF0F6]">
                            <li className="flex items-center justify-between text-heading">
                                <span className="text-sm leading-6 capitalize">subtotal</span>
                                <span className="text-sm leading-6 capitalize">
                                    <CurrencyCodeAdd price={orderData?.subtotal} />
                                </span>
                            </li>
                        </ul>
                        <div className="flex items-center justify-between p-3">
                            <h4 className="text-sm leading-6 font-semibold capitalize">total</h4>
                            <h5 className="text-sm leading-6 font-semibold capitalize">
                                <CurrencyCodeAdd price={orderData?.total} />
                            </h5>
                        </div>
                    </div>

                    <div className="flex flex-col gap-3" style={{ display: 'flex', visibility: 'visible' }}>
                        <button 
                            type="button" 
                            onClick={() => {
                                if (orderData?._id) {
                                    setPrintInvoiceModal(true);
                                }
                            }} 
                            disabled={!orderData?._id}
                            className="flex w-full items-center justify-center gap-2 px-4 py-3.5 rounded-full shadow-db-card bg-[#1AB759] hover:bg-[#15994a] disabled:opacity-50 disabled:cursor-not-allowed"
                            style={{ display: 'flex', visibility: 'visible' }}
                        >
                            <i className="lab lab-printer-line text-base font-medium text-white"></i>
                            <span className="text-base font-medium capitalize text-white">Print Receipt</span>
                        </button>
                        <button 
                            type="button" 
                            onClick={() => {
                                if (orderData?._id) {
                                    setPrintKitchenModal(true);
                                }
                            }} 
                            disabled={!orderData?._id}
                            className="flex w-full items-center justify-center gap-2 px-4 py-3.5 rounded-full shadow-db-card bg-[#FF6B35] hover:bg-[#e55a2a] disabled:opacity-50 disabled:cursor-not-allowed"
                            style={{ display: 'flex', visibility: 'visible' }}
                        >
                            <i className="lab lab-printer-line text-base font-medium text-white"></i>
                            <span className="text-base font-medium capitalize text-white">Print Kitchen Receipt</span>
                        </button>
                    </div>
                </div>
            </div>
            <PrintInvoiceModal modalOpen={printInvoiceModal} setModalOpen={setPrintInvoiceModal} receiptOrderId={orderData?._id} receiptType="customer" />
            <PrintInvoiceModal modalOpen={printKitchenModal} setModalOpen={setPrintKitchenModal} receiptOrderId={orderData?._id} receiptType="kitchen" />
        </>
    );
};

export default CartProductListSidebar;
